import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import type { BoxProps } from '@hivebrite/design-system/Box';
import { Label } from '@hivebrite/design-system/Label';
import type { LabelPosition } from '@hivebrite/design-system/Label';
import type { POSITIONS } from '@hivebrite/design-system/Tooltip';

interface InputTitleProps {
  label: string;
  id?: string;
  position?: LabelPosition;
  boxProps?: BoxProps;
  tooltip?: string;
  tooltipPosition?: (typeof POSITIONS)[keyof typeof POSITIONS];
}

const InputTitle = ({
  boxProps,
  id,
  label,
  position,
  tooltip,
  tooltipPosition,
}: InputTitleProps) => (
  <Box {...boxProps}>
    {typeof label === 'string' && id ? (
      <Label
        id={id}
        position={position}
        tooltip={tooltip}
        tooltipPosition={tooltipPosition}
      >
        {label}
      </Label>
    ) : (
      <FakeLabel>{label}</FakeLabel>
    )}
  </Box>
);

export default InputTitle;

const FakeLabel = styled(Box).attrs({
  fontWeight: 1,
})``;
